export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
};

export type GQLAlbumProps = {
  __typename?: 'AlbumProps';
  tracks: Maybe<Scalars['Int']['output']>;
  year: Maybe<Scalars['Int']['output']>;
};

export type GQLAuthor = {
  __typename?: 'Author';
  avatar: Maybe<Scalars['String']['output']>;
  followers: Maybe<Scalars['Int']['output']>;
  following: Maybe<Scalars['Int']['output']>;
  handle: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  monthlyViews: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  text: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};

export enum GQLChannel {
  Apple = 'apple',
  Facebook = 'facebook',
  Google = 'google',
  Instagram = 'instagram',
  News = 'news',
  Pinterest = 'pinterest',
  Spotify = 'spotify',
  Ticketmaster = 'ticketmaster',
  Tiktok = 'tiktok',
  Tmdb = 'tmdb',
  Twitch = 'twitch',
  Twitter = 'twitter',
  Youtube = 'youtube'
}

export type GQLChannelFilter = {
  tmdb?: InputMaybe<GQLTmdbFilter>;
};

export type GQLChannelProps = {
  __typename?: 'ChannelProps';
  twitter: Maybe<GQLTwitterProps>;
};

export type GQLComment = {
  __typename?: 'Comment';
  author: GQLAuthor;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  likes: Maybe<Scalars['Int']['output']>;
  link: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  vendorId: Scalars['ID']['output'];
};

export type GQLDescription = {
  __typename?: 'Description';
  html: Maybe<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
};

export enum GQLErrorCode {
  ChannelNotConnected = 'channelNotConnected',
  ChannelNotSupported = 'channelNotSupported',
  ConnectorNotConfigured = 'connectorNotConfigured',
  DisconnectFailed = 'disconnectFailed',
  InvalidState = 'invalidState',
  OauthCompleteFailed = 'oauthCompleteFailed',
  OauthInitFailed = 'oauthInitFailed',
  ProviderNotFound = 'providerNotFound',
  StateChannelMismatch = 'stateChannelMismatch',
  StateUserMismatch = 'stateUserMismatch',
  TokenExchangeFailed = 'tokenExchangeFailed',
  Unauthenticated = 'unauthenticated',
  UserNotFound = 'userNotFound'
}

export type GQLErrorResponse = {
  __typename?: 'ErrorResponse';
  code: GQLErrorCode;
  message: Scalars['String']['output'];
};

export type GQLEventFilter = {
  favourite?: InputMaybe<Scalars['Boolean']['input']>;
  scope?: InputMaybe<GQLEventScope>;
};

export type GQLEventProps = {
  __typename?: 'EventProps';
  city: Maybe<Scalars['String']['output']>;
  date: Scalars['DateTime']['output'];
  location: Scalars['String']['output'];
  scope: GQLEventScope;
};

export enum GQLEventScope {
  Global = 'global',
  Local = 'local'
}

export type GQLFile = {
  __typename?: 'File';
  extension: GQLFileExtension;
  filename: Scalars['String']['output'];
  filesize: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sizes: Maybe<Array<GQLImageSize>>;
  thumbnail: Scalars['String']['output'];
  type: GQLFileType;
};


export type GQLFileSizesArgs = {
  sizes?: InputMaybe<Array<GQLImageSizeInput>>;
};

export enum GQLFileExtension {
  Avi = 'avi',
  Doc = 'doc',
  Docx = 'docx',
  Gif = 'gif',
  Jpeg = 'jpeg',
  Jpg = 'jpg',
  Mov = 'mov',
  Mp3 = 'mp3',
  Mp4 = 'mp4',
  Pdf = 'pdf',
  Png = 'png',
  Svg = 'svg',
  Wav = 'wav',
  Webp = 'webp'
}

export enum GQLFileType {
  Audio = 'audio',
  Document = 'document',
  Image = 'image',
  Movie = 'movie',
  Tv = 'tv',
  Video = 'video'
}

export enum GQLGender {
  Diverse = 'diverse',
  Female = 'female',
  Male = 'male'
}

export type GQLImageSize = {
  __typename?: 'ImageSize';
  height: Maybe<Scalars['Int']['output']>;
  src: Scalars['String']['output'];
  width: Maybe<Scalars['Int']['output']>;
};

export type GQLImageSizeInput = {
  height?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLInterest = {
  __typename?: 'Interest';
  image: Maybe<GQLFile>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export enum GQLMarket {
  De = 'de',
  En = 'en'
}

export type GQLMutation = {
  __typename?: 'Mutation';
  completeSocialConnection: GQLResponseConnectSocial;
  createComment: GQLResponseCreateComment;
  disconnectSocialAccount: GQLResponseDisconnectSocial;
  initiateSocialConnection: GQLResponseSocialConnection;
  refreshSocialToken: GQLResponseConnectSocial;
  subscribe: GQLResponseSubscribe;
  updateUserWall: GQLResponseUpdateUserWall;
};


export type GQLMutationCompleteSocialConnectionArgs = {
  channel: GQLChannel;
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type GQLMutationCreateCommentArgs = {
  commentId?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  postId: Scalars['ID']['input'];
};


export type GQLMutationDisconnectSocialAccountArgs = {
  channel: GQLChannel;
};


export type GQLMutationInitiateSocialConnectionArgs = {
  channel: GQLChannel;
  redirectUri: Scalars['String']['input'];
};


export type GQLMutationRefreshSocialTokenArgs = {
  provider: Scalars['String']['input'];
};


export type GQLMutationSubscribeArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationUpdateUserWallArgs = {
  input: GQLUpdateUserWallInput;
};

export type GQLNewsProps = {
  __typename?: 'NewsProps';
  category: Maybe<Scalars['String']['output']>;
  subCategory: Maybe<Scalars['String']['output']>;
};

export type GQLPaginatedPostsResponse = {
  __typename?: 'PaginatedPostsResponse';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  items: Array<GQLPost>;
  maxPageSize: Scalars['Int']['output'];
};

export type GQLPaginatedSimilarPostsResponse = {
  __typename?: 'PaginatedSimilarPostsResponse';
  endCursor: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  items: Array<GQLPost>;
};

export type GQLPaginatedSubscriptionsResponse = {
  __typename?: 'PaginatedSubscriptionsResponse';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  items: Array<GQLSubscription>;
  maxPageSize: Scalars['Int']['output'];
};

export type GQLPaginatedTopicResponse = {
  __typename?: 'PaginatedTopicResponse';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  items: Array<GQLTopic>;
  maxPageSize: Scalars['Int']['output'];
};

export type GQLPagination = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type GQLPlaylistProps = {
  __typename?: 'PlaylistProps';
  tracks: Maybe<Scalars['Int']['output']>;
};

export type GQLPost = {
  __typename?: 'Post';
  author: Maybe<GQLAuthor>;
  channel: GQLChannel;
  channelProps: Maybe<GQLChannelProps>;
  children: Maybe<Array<GQLPost>>;
  comments: Maybe<Scalars['Int']['output']>;
  createdAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image: Maybe<Scalars['String']['output']>;
  likes: Maybe<Scalars['Int']['output']>;
  link: Maybe<Scalars['String']['output']>;
  media: Maybe<Array<Maybe<GQLPostMedia>>>;
  postType: GQLPostType;
  postTypeProps: Maybe<GQLPostTypeProps>;
  shortText: Maybe<Scalars['String']['output']>;
  showCommentsSection: Scalars['Boolean']['output'];
  showSimilarPostsSection: Scalars['Boolean']['output'];
  text: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  vendorId: Scalars['ID']['output'];
  video: Maybe<Scalars['String']['output']>;
};

export type GQLPostMedia = {
  __typename?: 'PostMedia';
  title: Maybe<Scalars['String']['output']>;
  type: GQLFileType;
  url: Scalars['String']['output'];
};

export enum GQLPostType {
  Album = 'album',
  Artist = 'artist',
  Channel = 'channel',
  Event = 'event',
  Image = 'image',
  Live = 'live',
  Movie = 'movie',
  News = 'news',
  Person = 'person',
  Playlist = 'playlist',
  Podcast = 'podcast',
  Post = 'post',
  Search = 'search',
  Show = 'show',
  Track = 'track',
  Tv = 'tv',
  Video = 'video'
}

export type GQLPostTypeFilter = {
  events?: InputMaybe<GQLEventFilter>;
};

export type GQLPostTypeProps = {
  __typename?: 'PostTypeProps';
  album: Maybe<GQLAlbumProps>;
  event: Maybe<GQLEventProps>;
  news: Maybe<GQLNewsProps>;
  playlist: Maybe<GQLPlaylistProps>;
  track: Maybe<GQLTrackProps>;
  video: Maybe<GQLVideoProps>;
};

export type GQLPostsFilter = {
  channelFilter?: InputMaybe<GQLChannelFilter>;
  channels?: InputMaybe<Array<GQLChannel>>;
  hashtags?: InputMaybe<Array<Scalars['String']['input']>>;
  interests?: InputMaybe<Array<Scalars['String']['input']>>;
  market?: InputMaybe<GQLMarket>;
  postTypeFilter?: InputMaybe<GQLPostTypeFilter>;
  postTypes?: InputMaybe<Array<GQLPostType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  searchMethod?: InputMaybe<GQLSearchMethod>;
};

export type GQLProfile = {
  __typename?: 'Profile';
  avatar: Maybe<GQLFile>;
  headerImage: Maybe<GQLFile>;
  id: Scalars['ID']['output'];
  type: GQLProfileType;
};

export enum GQLProfileType {
  Business = 'business',
  Private = 'private'
}

export type GQLQuery = {
  __typename?: 'Query';
  comments: Array<GQLComment>;
  me: Maybe<GQLUser>;
  postById: Maybe<GQLPost>;
  posts: GQLPaginatedPostsResponse;
  search: Maybe<GQLSearchResult>;
  similarPosts: GQLPaginatedSimilarPostsResponse;
  subscriptions: GQLPaginatedSubscriptionsResponse;
  topic: GQLPaginatedPostsResponse;
  topicTrends: GQLPaginatedTopicResponse;
  userWall: Array<GQLWallElement>;
};


export type GQLQueryCommentsArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryPostByIdArgs = {
  id: Scalars['String']['input'];
};


export type GQLQueryPostsArgs = {
  filter?: InputMaybe<GQLPostsFilter>;
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sortBy?: InputMaybe<GQLSortBy>;
  sortDirection?: InputMaybe<GQLSortDirection>;
};


export type GQLQuerySearchArgs = {
  keyword: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
};


export type GQLQuerySimilarPostsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
};


export type GQLQuerySubscriptionsArgs = {
  filter?: InputMaybe<GQLSubscriptionsFilter>;
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<GQLSortDirection>;
};


export type GQLQueryTopicArgs = {
  channel: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
  searchMethod?: InputMaybe<GQLSearchMethod>;
};


export type GQLQueryTopicTrendsArgs = {
  filter?: InputMaybe<GQLTopicFilter>;
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type GQLQueryUserWallArgs = {
  profileId: Scalars['ID']['input'];
};

export type GQLResponseConnectSocial = {
  __typename?: 'ResponseConnectSocial';
  error: Maybe<GQLErrorResponse>;
  socialAccount: GQLSocialAccount;
  status: GQLResponseStatus;
};

export type GQLResponseCreateComment = {
  __typename?: 'ResponseCreateComment';
  comment: GQLComment;
  error: Maybe<GQLErrorResponse>;
  status: GQLResponseStatus;
};

export type GQLResponseDisconnectSocial = {
  __typename?: 'ResponseDisconnectSocial';
  error: Maybe<GQLErrorResponse>;
  status: GQLResponseStatus;
};

export type GQLResponseSocialConnection = {
  __typename?: 'ResponseSocialConnection';
  authUrl: Scalars['String']['output'];
  error: Maybe<GQLErrorResponse>;
  state: Scalars['String']['output'];
  status: GQLResponseStatus;
};

export enum GQLResponseStatus {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}

export type GQLResponseSubscribe = {
  __typename?: 'ResponseSubscribe';
  error: Maybe<GQLErrorResponse>;
  status: GQLResponseStatus;
  subscription: GQLSubscription;
};

export type GQLResponseUpdateUserWall = {
  __typename?: 'ResponseUpdateUserWall';
  error: Maybe<GQLErrorResponse>;
  status: GQLResponseStatus;
};

export enum GQLRole {
  Admin = 'admin',
  User = 'user'
}

export enum GQLSearchMethod {
  Default = 'default',
  TopicId = 'topicId',
  Username = 'username'
}

export type GQLSearchResult = {
  __typename?: 'SearchResult';
  appearance: Maybe<GQLSearchResultAppearance>;
  description: Maybe<GQLDescription>;
  image: Maybe<GQLFile>;
  name: Scalars['String']['output'];
  realclixProfile: Maybe<GQLProfile>;
  socials: Array<GQLSocialChannel>;
};

export enum GQLSearchResultAppearance {
  Celebrity = 'celebrity',
  Company = 'company',
  ContentCreator = 'contentCreator',
  NonProfit = 'nonProfit',
  Other = 'other',
  Politician = 'politician'
}

export type GQLSocialAccount = {
  __typename?: 'SocialAccount';
  accessToken: Maybe<Scalars['String']['output']>;
  channel: GQLChannel;
  isConnected: Maybe<Scalars['Boolean']['output']>;
  lastConnection: Maybe<Scalars['DateTime']['output']>;
  metadata: Maybe<Scalars['String']['output']>;
  providerAccountId: Maybe<Scalars['String']['output']>;
  refreshToken: Maybe<Scalars['String']['output']>;
  scope: Maybe<Scalars['String']['output']>;
  tokenExpiresAt: Maybe<Scalars['String']['output']>;
};

export type GQLSocialChannel = {
  __typename?: 'SocialChannel';
  channel: GQLChannel;
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
};

export enum GQLSortBy {
  Popularity = 'popularity',
  PublicationDate = 'publicationDate',
  UserVoting = 'userVoting'
}

export enum GQLSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type GQLSubscription = {
  __typename?: 'Subscription';
  avatar: Maybe<GQLFile>;
  channel: GQLChannel;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLSubscriptionsFilter = {
  channels?: InputMaybe<Array<GQLChannel>>;
};

export type GQLTmdbFilter = {
  certification?: InputMaybe<Scalars['Int']['input']>;
  certificationCountry?: InputMaybe<Scalars['String']['input']>;
  releaseDateGte?: InputMaybe<Scalars['String']['input']>;
  releaseDateLte?: InputMaybe<Scalars['String']['input']>;
  voteAverageGte?: InputMaybe<Scalars['Int']['input']>;
  voteCountGte?: InputMaybe<Scalars['Int']['input']>;
  withCast?: InputMaybe<Scalars['String']['input']>;
  withGenres?: InputMaybe<Scalars['String']['input']>;
  withRuntimeGte?: InputMaybe<Scalars['Int']['input']>;
  withRuntimeLte?: InputMaybe<Scalars['Int']['input']>;
  withWatchProviders?: InputMaybe<Scalars['String']['input']>;
};

export enum GQLTmdbSortBy {
  PopularityAsc = 'popularityAsc',
  PopularityDesc = 'popularityDesc',
  ReleaseDateAsc = 'releaseDateAsc',
  ReleaseDateDesc = 'releaseDateDesc',
  VoteAverageAsc = 'voteAverageAsc',
  VoteAverageDesc = 'voteAverageDesc',
  VoteCountAsc = 'voteCountAsc',
  VoteCountDesc = 'voteCountDesc'
}

export type GQLTopic = {
  __typename?: 'Topic';
  id: Scalars['String']['output'];
  image: Maybe<GQLFile>;
  name: Scalars['String']['output'];
};

export type GQLTopicFilter = {
  channel: GQLChannel;
  keyword?: InputMaybe<Scalars['String']['input']>;
};

export type GQLTrackProps = {
  __typename?: 'TrackProps';
  duration: Maybe<Scalars['Int']['output']>;
  year: Maybe<Scalars['Int']['output']>;
};

export type GQLTwitterProps = {
  __typename?: 'TwitterProps';
  retweets: Scalars['Int']['output'];
};

export type GQLUpdateUserWallInput = {
  elements: Array<GQLWallElementInput>;
};

export type GQLUser = {
  __typename?: 'User';
  createdAt: Scalars['DateTime']['output'];
  currentProfile: GQLProfile;
  email: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  gender: Maybe<GQLGender>;
  hashtags: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interests: Maybe<Array<GQLInterest>>;
  lastName: Scalars['String']['output'];
  profiles: Array<GQLProfile>;
  roles: Array<GQLRole>;
  socialAccounts: Array<GQLSocialAccount>;
  updatedAt: Scalars['DateTime']['output'];
  username: Scalars['String']['output'];
};

export type GQLVideoProps = {
  __typename?: 'VideoProps';
  duration: Maybe<Scalars['Int']['output']>;
  views: Maybe<Scalars['Int']['output']>;
};

export type GQLWallElement = {
  __typename?: 'WallElement';
  data: GQLWallElementData;
  id: Scalars['ID']['output'];
  size: GQLWallElementSize;
  type: GQLWallElementType;
};

export type GQLWallElementData = {
  __typename?: 'WallElementData';
  image: Maybe<Scalars['String']['output']>;
  post: Maybe<GQLPost>;
  text: Maybe<Scalars['String']['output']>;
  type: Maybe<GQLWallElementType>;
  video: Maybe<Scalars['String']['output']>;
};

export type GQLWallElementDataInput = {
  image?: InputMaybe<Scalars['String']['input']>;
  socialUrl?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type GQLWallElementInput = {
  data: GQLWallElementDataInput;
  size: GQLWallElementSize;
  type: GQLWallElementType;
};

export enum GQLWallElementSize {
  FullWidth = 'fullWidth',
  OneThirds = 'oneThirds',
  TwoThirds = 'twoThirds'
}

export enum GQLWallElementType {
  Image = 'image',
  Post = 'post',
  Text = 'text',
  Video = 'video'
}
